import Stat from '@/views/Stat';
import MapView from '@/views/Map';

export default [
  {
    path: '/',
    redirect: '/stat',
  },
  {
    path: '/stat',
    name: 'stat',
    component: Stat
  },
  {
    path: '/map',
    name: 'map',
    component: MapView
  },
  {
    path: '*',
    redirect: '/'
    // component: NotFound
  }
];
